import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
export interface ProgressBarProps {
  progress: number;
}
const ProgressBar = t0 => {
  const $ = _c(7);
  const {
    progress
  } = t0;
  const t1 = `${progress}%`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="h-[12px] w-[calc(100%-36px)] rounded-lg"><div className="border-text-primary/30 h-full rounded-lg border"><div className="bg-text-primary h-full rounded-lg" style={{
          width: t1
        }} /></div></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== progress) {
    t3 = <span className="text-text-tertiary text-sm">{progress}%</span>;
    $[2] = progress;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex w-[200px] items-center gap-1 lg:w-full">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default ProgressBar;